import React from 'react';
import { HashRouter, Route } from 'react-router-dom';

import Home from './pages/Home'
import Onshore from './pages/Onshore';
import About from './pages/About';
import Solar from './pages/Solar';
import PMS from './pages/PMS';
import CMS from './pages/CMS';
import Contact from './pages/Contact';
import Sustainability from './pages/Sustainability';
import Windfarm from './pages/Windfarm';
import Stories from './pages/Stories';
import WindIntelli from './pages/WindIntelli';
import Alegria1 from './pages/Windfarms/Alegria1';
import Alegria2 from './pages/Windfarms/Alegria2';
import Gravata from './pages/Windfarms/Gravata';
import Pedra from './pages/Windfarms/Pedra';
import Piraua from './pages/Windfarms/Piraua';
import { Carrer } from './pages/Careers/Index';

function Routes() {
  return (
    <HashRouter>
      <Route path="/" exact component={Home} />
      <Route path="/aboutus" component={About} />
      <Route path="/onshore" component={Onshore} />
      <Route path="/solar" component={Solar} />
      <Route path="/pms" component={PMS} />
      <Route path="/cms" component={CMS} />
      <Route path="/contact" component={Contact} />
      <Route path="/sustainability" component={Sustainability} />
      <Route path="/windfarm" component={Windfarm} />
      <Route path="/stories" component={Stories} />
      <Route path="/careers" component={Carrer} />
      <Route path="/windintelli" component={WindIntelli} />
      <Route path="/alegria_1" component={Alegria1} />
      <Route path="/alegria_2" component={Alegria2} />
      <Route path="/gravata" component={Gravata} />
      <Route path="/pedra_do_reino3" component={Pedra} />
      <Route path="/piraua" component={Piraua} />
    </HashRouter>
  )
}

export default Routes;
